var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64696F",
    d: "M5.681 3.603a.74.74 0 0 0-.204-.545.73.73 0 0 0-.543-.205.73.73 0 0 0-.377.098.9.9 0 0 0-.29.288.43.43 0 0 1-.314.21.39.39 0 0 1-.34-.115.4.4 0 0 1-.112-.252.5.5 0 0 1 .068-.285q.23-.378.586-.588T4.935 2q.696 0 1.13.434.435.435.435 1.137 0 .355-.136.64-.138.284-.503.67a3 3 0 0 0-.36.431.9.9 0 0 0-.122.351.57.57 0 0 1-.147.316.38.38 0 0 1-.284.126.38.38 0 0 1-.283-.122.42.42 0 0 1-.119-.304q0-.308.122-.564.122-.257.41-.541.366-.356.485-.549a.8.8 0 0 0 .118-.422M4.934 8a.53.53 0 0 1-.406-.185.64.64 0 0 1-.169-.447q0-.26.17-.445a.53.53 0 0 1 .405-.186.53.53 0 0 1 .406.186.64.64 0 0 1 .169.445.64.64 0 0 1-.169.447.53.53 0 0 1-.406.185"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    stroke: "#64696F"
  })));
};
export default SvgQuestionMark;